<div #sliderContainer
     class="td-wb-pagination-slider-container"
     [attr.aria-label]="'tdWb.pagination-slider.SLIDER_ARIA_LABEL' | translate"
     [style.--rows-per-slide]="rows()"
     [style.--columns-per-view]="columns()"
     [class.td-wb-pagination-slider-container--grid]="isGrid()">
  <div class="td-wb-pagination-slider-wrapper">
    <div class="td-wb-pagination-slider-track"
         [style.transform]="sliderTrackTransform()">
     @for(slide of slides(); track $index; let slideIndex = $index) {
      <div class="td-wb-pagination-slider-slide"
           [class.single-item]="isMobile()"
           role="group"
           [attr.aria-label]="'tdWb.pagination-slider.SLIDE_ARIA_LABEL' | translate: { current: slideIndex + 1, total: totalSlides() }"
           [attr.aria.hidden]= "slideIndex !== currentSlide()">
      @for (item of slide; track $index; let i = $index) {
        <div #allItems
             role="button"
             tabindex="0"
             class="td-wb-pagination-slider-item"
             (click)="onItemClick(item)"
             (keydown.enter)="onItemClick(item)"
             (keydown.space)="onItemClick(item)">
          @if (itemTemplate()) {
            <ng-container *ngTemplateOutlet="itemTemplate()!; context: { $implicit: item, index: i }"/>
          }
        </div>
      }
    </div>
  }
   </div>
  </div>
  @if (showNavigation() && totalSlides() > 1) {
    <div class="td-wb-pagination-slider-dots-arrow">
      <button class="td-wb-pagination-slider-arrow td-wb-pagination-slider-arrow--left"
              (click)="prev()"
              [disabled]="!canGoPrev()"
              aria-label="'tdWb.pagination-slider.PREVIOUS' | tdWbTranslate">
        <td-wb-icon size="10"
                    iconId="arrow-left"/>
      </button>
      @if (displayDots()) {
        <!--display dots-->
        @for (i of slideIndices(); track i) {
          <button [id]="'td-wb-pagination-slider-dot-' + i"
                  class="td-wb-pagination-slider-dot"
                  [class.active]="currentSlide() === i"
                  (click)="goToSlide(i)"
                  [attr.aria-label]="'Go to slide ' + (i+1)">
          </button>
        }
      } @else {
        <!--display current slide count-->
        <div id="td-wb-pagination-slider-count"
             translate="tdWb.pagination-slider.COUNT"
             [translateParams]="{ count: currentSlide() + 1, total: items().length }">
        </div>
      }
      <button class="td-wb-pagination-slider-arrow td-wb-pagination-slider-arrow--right"
              (click)="next()"
              [disabled]="!canGoNext()"
              aria-label="'tdWb.pagination-slider.NEXT' | tdWbTranslate">
        <td-wb-icon size="10"
                    iconId="arrow-right"/>
      </button>
    </div>
  }
</div>
